var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBooking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 349,
    viewBox: "0 0 1200 349",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1199,
    height: 348,
    rx: 13.5,
    stroke: "url(#paint0_linear_705_3939)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_705_3939",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1200,
    height: 349
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1199,
    height: 348,
    rx: 13.5,
    fill: "#D9D9D9",
    stroke: "url(#paint1_linear_705_3939)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_705_3939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1200 348.44H0.368896",
    stroke: "#F1F3F5",
    strokeOpacity: 0.1,
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.06 348.07V-4.21339",
    stroke: "#F1F3F5",
    strokeOpacity: 0.1,
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.5 348.07V-4.21339",
    stroke: "#F1F3F5",
    strokeOpacity: 0.1,
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.927 348.07V-4.21339",
    stroke: "#F1F3F5",
    strokeOpacity: 0.1,
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.361 348.07V-4.21339",
    stroke: "#F1F3F5",
    strokeOpacity: 0.1,
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.795 348.07V-4.21339",
    stroke: "#F1F3F5",
    strokeOpacity: 0.1,
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.229 348.07V-4.21339",
    stroke: "#F1F3F5",
    strokeOpacity: 0.1,
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.663 348.07V-4.21339",
    stroke: "#F1F3F5",
    strokeOpacity: 0.1,
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.097 348.071V-4.21339",
    stroke: "#F1F3F5",
    strokeOpacity: 0.1,
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.531 348.071V-4.21339",
    stroke: "#F1F3F5",
    strokeOpacity: 0.1,
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.964 348.071V-4.21339",
    stroke: "#F1F3F5",
    strokeOpacity: 0.1,
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.398 348.071V-4.21339",
    stroke: "#F1F3F5",
    strokeOpacity: 0.1,
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.83 348.071V-4.21339",
    stroke: "#F1F3F5",
    strokeOpacity: 0.1,
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.265 348.071V-4.21339",
    stroke: "#F1F3F5",
    strokeOpacity: 0.1,
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.698 348.071V-4.21339",
    stroke: "#F1F3F5",
    strokeOpacity: 0.1,
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.476 250.15V-4.21393",
    stroke: "url(#paint2_radial_705_3939)",
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.804 374.112V119.748",
    stroke: "url(#paint3_radial_705_3939)",
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.983 187.364V-67",
    stroke: "url(#paint4_radial_705_3939)",
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.655 191.657V-62.7069",
    stroke: "url(#paint5_radial_705_3939)",
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.46 298.984V44.6197",
    stroke: "url(#paint6_radial_705_3939)",
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.132 348.071V-4.21339",
    stroke: "#F1F3F5",
    strokeOpacity: 0.1,
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5652 348.071L70.5647 -4.21339",
    stroke: "#F1F3F5",
    strokeOpacity: 0.1,
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 277.984H0.368896",
    stroke: "#F1F3F5",
    strokeOpacity: 0.1,
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 207.526H0.368896",
    stroke: "#F1F3F5",
    strokeOpacity: 0.1,
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 137.07H0.368896",
    stroke: "#F1F3F5",
    strokeOpacity: 0.1,
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 66.6131H0.368896",
    stroke: "#F1F3F5",
    strokeOpacity: 0.1,
    strokeWidth: 0.885667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.032 277.614H775.59V208.164H706.032V277.614Z",
    fill: "#E6DAFE",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.73 136.7H987.288V67.2501L917.73 67.2501V136.7Z",
    fill: "#E6DAFE",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.334 136.7H563.892V67.2501L494.334 67.2501V136.7Z",
    fill: "#E6DAFE",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.633 277.614H352.191V208.164H282.633V277.614Z",
    fill: "white",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.067 207.157H281.626V137.707H212.067V207.157Z",
    fill: "white",
    fillOpacity: 0.04
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_705_3939",
    x1: 0,
    y1: 174.5,
    x2: 1200,
    y2: 174.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#E6DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2944"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_705_3939",
    x1: 0,
    y1: 174.5,
    x2: 1200,
    y2: 174.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#E6DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2944"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_705_3939",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(nan nan) rotate(nan) scale(nan nan)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#FFF250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF250",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_705_3939",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(nan nan) rotate(nan) scale(nan nan)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#FFF250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF250",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_705_3939",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(nan nan) rotate(nan) scale(nan nan)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#FFF250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF250",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_705_3939",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(nan nan) rotate(nan) scale(nan nan)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#FFF250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF250",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_705_3939",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(nan nan) rotate(nan) scale(nan nan)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#FFF250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF250",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/booking.538e511aaa7e1eb6801df7d08d8d9b4e.svg";
export { ForwardRef as ReactComponent };